export function getEventKeyMoments(event, { type, format }) {
  if (!event.keyMoments?.[type]) {
    return event.keyDates?.[type]
  }

  return event.keyMoments?.[type]?.find(keyMoment => keyMoment.format === format) || undefined;
}

